import api from "../../Services/api";

export const fetchFilledForms = async () => {
  try {
    const response = await api.get("/filled-forms/all", {
      data: {},
    });
    return response.data.filledForms;
  } catch (error) {
    console.error("Error fetching Filled forms:", error);
    throw error;
  }
};
